// extracted by mini-css-extract-plugin
module.exports = {"loader":"loading_loader__aPFvr","rotate0234":"loading_rotate0234__hZ0uo","dot":"loading_dot__k_qUP","text":"loading_text__uJP9F"};